import { BookOpen, Bot, FolderLock, Gauge, ShieldCheck, SquareTerminal, Users } from 'lucide-react';

import { type MenuItem } from './nav-main';

export const navigationItems: MenuItem[] = [
  {
    title: 'Dashboard',
    url: '/dashboard',
    icon: Gauge,
    description: 'Overview of key metrics & quick actions',
  },
  {
    title: 'Business Groups',
    url: '/business-groups',
    icon: SquareTerminal,
    description: 'Manage Business Groups (users, assignments)',
    linkState: { allowEmpty: true },
  },
  {
    title: 'Configuration',
    icon: Bot,
    url: '#',
    items: [
      {
        title: 'Business Groups',
        url: '/configuration/business-groups',
        description: 'Configure Business Groups.',
      },
      {
        title: 'Users',
        url: '/configuration/users',
        description: 'Manage SFTP Users.',
      },
      {
        title: 'Assignments',
        url: '/configuration/assignments',
        description: 'Manage assignments across Business Groups.',
      },
      {
        title: 'Products',
        url: '/configuration/products',
        description: 'Create and manage products.',
      },
      {
        title: 'Landing Folder Restrictions',
        url: '/configuration/landing-folder-restrictions',
        description: 'Create and manage restrictions.',
      },
    ],
    description: 'Configuration settings',
  },
  {
    title: 'Retention Policies',
    url: '/retentions',
    icon: BookOpen,
    description: 'Manage retention policies.',
  },
  {
    title: 'Directory Permissions',
    url: '/directory-permissions',
    icon: FolderLock,
    description: 'Manage directory permissions.',
  },
  {
    title: 'Content Access Roles',
    url: '/content-access-roles',
    icon: ShieldCheck,
    description: 'Manage content access roles.',
  },
  {
    title: 'Operator Users & Groups',
    url: '#',
    icon: Users,
    description: 'Manage users and user groups.',
    items: [
      {
        title: 'Operator Users',
        url: '/operators/users',
        description: 'Configure Operator Users.',
      },
      {
        title: 'Operator Groups',
        url: '/operators/groups',
        description: 'Configure Operator Groups.',
      },
    ],
  },
];
